jQuery(window).load(function(){
  

  
  $('.flexslider').flexslider({
    animation: "slide",
    slideshow: true,
    animationDuration: 700,
    slideshowSpeed: 6000,
    animation: "fade",
    controlsContainer: ".flex-controls",
    randomize: true,
    controlNav: false,
    keyboardNav: true
  }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});
  
  $("select.loc_on_change").change(function(){
  	if($(this).find(":selected").attr("value") == "#") return false;
  	window.location = $(this).find(":selected").attr("value");
  });
    
  
  var IE6 = false /*@cc_on || @_jscript_version < 5.7 @*/;
  if(IE6){
    if($("#placeholder img").width() > 360){
      $("#placeholder img").css('width', '360px');
    } else {
      $("#placeholder img").css('width', $("#placeholder img").width()+'px'); // restrict to initial width of image
    }
  } else {
    $("#placeholder img").css('maxWidth', $("#placeholder img").width()+'px'); // restrict to initial width of image
  }

  var pw = $("#placeholder img").width() + 8;
  $("#placeholder img").parents('div.featured').css('maxWidth', pw+'px'); // force IE to play nice
  
});

jQuery(document).ready(function($){
  	
  




  $("a.zoom").click(function() {
    $('#product .thumbs a').eq(0).trigger('click');
    return false;
  });

  $('#product .thumbs a').fancybox({
    padding:0,
    'titleShow': false,
    overlayColor: '#000000',
    overlayOpacity: 0.2,
    nextEffect: 'fade',
    prevEffect: 'fade',
    arrows: false,
    nextClick: true
  });

  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
  




  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })
  
  $('li.dropdown').hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });



  // make mobile menu slide out/in on all pages  var doShow = true;
  var doShow = true;

  // slide mobile menu out/in
  $( '.coho-mobile-nav__icon' ).click( function(e) {
    e.preventDefault();
    $( '.coho-mobile-nav__menu-container' ).toggle( "slide", { direction:'left' } );
    doShow = !doShow;
  });

  // close mobile menu if clicked outside of menu
  $( 'body' ).click( function(e) {
    if( !$( e.target ).closest( '.coho-mobile-nav__icon' ).length && doShow === false ) {
      $( '.coho-mobile-nav__menu-container' ).toggle( "slide", { direction:'left' } );
      doShow = true;
    }
  });




  // smooth scrolling
  $( 'a[href*=#]:not([href=#])' ).click( function() {
    if ( location.pathname.replace( /^\//,'' ) == this.pathname.replace( /^\//, '' ) && location.hostname == this.hostname ) {
      var target = $( this.hash );
      target = target.length ? target : $( '[name=' + this.hash.slice( 1 ) + ']' );
      if ( target.length ) {
        scrollToSection( target, 20, 750 );
        return false;
      }
    }
  }); // end click function

  
  // bind scrolling to event handler  
  $( window ).scroll( function() {
    onScrollWindow();
  }); // end scroll


  // Scroll event handler
  onScrollWindow = function() {
    // show the back-to-top button only when scrolled down from top by more than n the viewport height.
    var intViewportHeight = window.innerHeight * 0.2;
    
    if ( $( window ).scrollTop() >= intViewportHeight ) {
      $( '.coho-back-to-top-wrap' ).fadeIn();
    } else {
      $( '.coho-back-to-top-wrap' ).fadeOut();
    }
    
    return false;
    
  }; // end onScrollWindow


  scrollToSection = function( anchor, pixelOffset, duration ) {
    
    //console.log( 'FUNCTION FIRED: scrollToNextSection' );
    var divPosition = $( anchor ).offset();
    //console.log( divPosition );
    $( 'html, body' ).animate( { scrollTop : divPosition.top - pixelOffset }, duration );
  };





});